// Status should match the ENUM values menitoned in
// https://unsightly-rock.cloudvent.net/data-transfer-objects/ingestion-summary-dto/
export const STATUS_ANALYZING = 'ANALYZING';

export const HTTP_ERROR_CODE_DUPLICATE_COURSENAME = 409;

export const UPLOAD_FAILED = 1;
export const UPLOAD_PROGRESS = 2;
export const UPLOAD_COMPLETED = 3;

export const COURSE_FORMAT_LIST_EPUB = Object.freeze({
  EPUB_ETEXT: 'EPUB_ETEXT',
  EPUB_BRONTE_VIEWER: 'EPUB_BRONTE_VIEWER',
  BRONTE_VIEWER_STITCHED_LESSON: 'BRONTE_VIEWER_STITCHED_LESSON',
  WORD_ETEXT: 'WORD_ETEXT',
});

export const COURSE_FORMAT_LIST_WORD_BV = Object.freeze({
  WORD_BVPLUGIN: 'WORD_BVPLUGIN',
});

export const COURSE_FORMAT_LIST_WORD = Object.freeze({
  WORD_STUDY_CHANNEL: 'WORD_STUDY_CHANNEL',
});

export const COURSE_FORMAT_LIST_AMBROSIA = Object.freeze({
  AMBROSIA_IMPORT: 'AMBROSIA_IMPORT',
});